import { toast } from "react-toastify";
import { store } from "../redux/store";
import { selectIsOffline } from "../redux/slices/networkSlice";

export function isNetworkOffline() {
  return selectIsOffline(store.getState());
}

export function requireNetwork(
  message = "You're offline. Connect to the internet to continue."
) {
  if (isNetworkOffline()) {
    toast.warning(message, { autoClose: 3500 });
    return false;
  }
  return true;
}
